// HomePage.jsx
import React from "react";
import "../../../styles/pages-styles/main-dashboard-pages-styles/home-pages-styles/HomePage.css";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="homepage-container">
      <div className="welcome-section">
        <h1 className="welcome-heading">Welcome back</h1>
        <p className="welcome-subheading">Continue your learning journey</p>
      </div>

      <div className="cards">
        <div className="feature-card question-card">
          <h4>Question Bank</h4>
          <div className="card-content">
            <p>
              Access and practice with various questions to test your knowledge
              and prepare for exams
            </p>
          </div>
          <div className="card-action">
            <a
              href="/dashboard/question-questionbank"
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("/dashboard/question-questionbank");
              }}
            >
              Continue Here
              <ArrowRight className="arrow-icon" />
            </a>
          </div>
        </div>

        <div className="feature-card knowledge-card">
          <h4>Knowledge Tutor</h4>
          <div className="card-content">
            <p>
              Learn concepts with personalized tutoring sessions tailored to
              your learning pace
            </p>
          </div>
          <div className="card-action">
            <a
              href="/dashboard/knowledge"
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("/dashboard/knowledge");
              }}
            >
              Continue Here
              <ArrowRight className="arrow-icon" />
            </a>
          </div>
        </div>

        <div className="feature-card revision-card">
          <h4>Mock Exams</h4>
          <div className="card-content">
            <p>
              Take timed mock exams to simulate real testing conditions and
              track your progress
            </p>
          </div>
          <div className="card-action">
            <a
              href="/dashboard/question-mockexam"
              onClick={(e) => {
                e.preventDefault();
                handleNavigation("/dashboard/question-mockexam");
              }}
            >
              Continue Here
              <ArrowRight className="arrow-icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="resources-section">
        <h2>Additional Resources</h2>
        <div className="resources-container">
          <div className="resource-card textbook-card">
            <h4>Digital Textbooks</h4>
            <p>
              Access your comprehensive digital textbooks and study materials
            </p>
            <div className="card-action">
              <a
                href="/dashboard/textbook"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("/dashboard/textbook");
                }}
              >
                Browse Library <ArrowRight className="arrow-icon" />
              </a>
            </div>
          </div>

          <div className="resource-card premium-card">
            <h4>Premium Plan</h4>
            <p>
              Unlock advanced features and exclusive content with our premium
              subscription
            </p>
            <div className="card-action">
              <a
                href="/dashboard/subscribe"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("/dashboard/subscribe");
                }}
              >
                Upgrade Now <ArrowRight className="arrow-icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
